"use strict";

require("@polkadot/wasm-crypto/crypto-polyfill");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@polkadot/util-crypto/polyfill.js
// module id = 11
// module chunks = 0